import { useState, useEffect } from "react";                    
import swal from 'sweetalert2';                     
import { getSubscriptionReportData } from "../api/reportsAPI";
import moment from "moment";
import { exportToExcel } from "../global/helper";

const SubscriptionReport = (props) => {
    const [isInit,                          setIsInit]                = useState(true);
    const [subscriptionReport,              setSubscriptionReport]    = useState(null);
    const [subscriptionTable,               setSubscriptionTable]     = useState(null);

    useEffect(() => {
        props.title('Subscription Report', 'subscription-report');

        getSubscriptionReport();
    }, []);

    useEffect(() => {
        if (!isInit) {
            fillTable();
        }
    }, [subscriptionReport]);

    const getSubscriptionReport = async() => {
        try {
            swal.fire({
                titleText: 'Loading',
                text: 'Please Wait...',
                showConfirmButton: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });

            const response = await getSubscriptionReportData();
            isInit ? setIsInit(false) : $('#tblSubscriptionReport').KTDatatable().destroy();
            setSubscriptionReport(response);
            swal.close();
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            });
        }
    };

    function fillTable() {
        swal.close();
        const userData = subscriptionReport.User;

        const tblSubscription = $('#tblSubscriptionReport').KTDatatable({
            data: {
                saveState: false,
                source: userData
            },
            layout: {
                scroll: false,
                footer: false,
            },
            sortable: false,
            pagination: true,
            search: {
                input: $('#generalSearch'),
            },
            columns: [
                {
                    field: 'MembershipNo',
                    title: 'Membership No'
                },
                {
                    field: '',
                    title: 'Name',
                    template: function(row) {
                        return row['FirstName'] + ' ' + row['LastName'];
                    }
                },
                {
                    field: 'SubCategoryName',
                    title: 'Category'
                },
                {
                    field: 'Email',
                    title: 'Email'
                },
                {
                    field: 'Mobile',
                    title: 'Mobile'
                },
                // {
                //     field: 'SubscriptionExpiresOn',
                //     title: 'Subs Exp On',
                //     template: function(row) {
                //         const isExpired = row.SubscriptionExpiresOn?.toString().toUpperCase() === 'Y';
                //         const formattedDate = row.SubscriptionExpiresOn 
                //             ? moment(row.SubscriptionExpiresOn).format('DD-MMM-YYYY') 
                //             : '';

                //         if (isExpired) {
                //             return "<span class='label label-danger'>" + formattedDate + "</span>";
                //         } else {
                //             return formattedDate;
                //         }
                //     }
                // },
                // {
                //     field: 'SubsriptionUpdatedBy',
                //     title: 'Subs Updated By'
                // },
                // {
                //     field: 'SubscriptionUpdatedOn',
                //     title: 'Subs Updated On',
                //     template: function(row) {
                //         if (row.SubscriptionUpdatedOn == null) {
                //             return '';
                //         } else {
                //             return moment(row.SubscriptionUpdatedOn).format('DD MMM YYYY, h:mm:ss a');
                //         }
                //     }
                // },
                {
                    field: 'Code',
                    title: 'Subscription Type',
                    template: function (row) {
                        let plan = row?.Plan ? row?.Plan : '';
                        return row?.Code == 'Expired' ? `${plan}<span style="width: 60px;" class="kt-badge kt-badge--grey kt-badge--pill padding-lr30 padding-tb10"> Expired </span>` : `${plan}<span  style="width: 0px;" class="kt-badge kt-badge--unified-${row?.MembershipType == 'Golf & Resort Membership' ? 'success' : 'primary'} kt-badge--pill  kt-badge--bold padding-lr20 padding-tb10">${row?.Code}</span>`
                    },
                    
                },
                {
                    field: 'SubscriptionExpiresOn',
                    title: 'Subs Exp On',
                    template: (row) => row.SubscriptionExpiresOn && moment(row.SubscriptionExpiresOn).format("DD-MM-YYYY") 
                },
                {
                    field: 'MembershipType',
                    title: 'Membs Type',
                    template: (row) => row.MembershipType || ''
                },
                {
                    field: 'MembershipExpiresOn',
                    title: 'Membs Exp On',
                    template: (row) => moment(row.MembershipExpiresOn).format("DD-MM-YYYY")
                },
                {
                    field: 'MembershipStatus',
                    title: 'Membs status',
                    template: function(row) {
                        // if (row.IsMembershipExpires == 'N') {
                        //     return '<span style="width: 60px;" class="kt-badge kt-badge--grey kt-badge--pill padding-lr30 padding-tb10"> Expired </span>';
                        // } else {
                        //     return '<span style="width: 60px;" class="kt-badge kt-badge--unified-success kt-badge--pill  kt-badge--bold padding-lr20 padding-tb10">Valid</span>';
                        // }
                        if (row.IsMembershipExpires == 'N') {
                            return '<span class="kt-badge kt-badge--grey kt-badge--pill padding-lr30 padding-tb10">Expired</span>';
                        } 
                        else if (row.IsSubscriptionExpires == 'N') {
                            return '<span class="kt-badge kt-badge--warning kt-badge--pill padding-lr30 padding-tb10">Block</span>';
                        } 
                        else {
                            return '<span class="kt-badge kt-badge--unified-success kt-badge--pill kt-badge--bold padding-lr30 padding-tb10">Active</span>';
                        }
                    }
                },
                {
                    field: 'IPSCSubscriptionExpiresOn',
                    title: 'IPSC Exp On',
                    template: (row) => row.IPSCSubscriptionExpiresOn ? moment(row.IPSCSubscriptionExpiresOn).format("DD-MM-YYYY") : ''
                },
                {
                    field: 'IsIPSCValid',
                    title: 'IPSC status',
                    template: function(row) {
                        if (row.IsIPSCValid == 'N') {
                            return '<span style="width: 60px;" class="kt-badge kt-badge--grey kt-badge--pill padding-lr30 padding-tb10"> Expired </span>';
                        } else {
                            return '<span style="width: 60px;" class="kt-badge kt-badge--unified-success kt-badge--pill  kt-badge--bold padding-lr20 padding-tb10">Valid</span>';
                        }
                    }
                },
            ],
            rows: {
                autoHide: false,
            }
        });
        $('#root .kt-grid--hor').addClass('max-width100');
        $('#tblSubscriptionReport .kt-datatable__table').addClass('overflow-x-auto');

        Config.Core.InitPopover();
        Config.Core.GrabAndScroll('.kt-datatable__table');

        const SubscriptionTable = $('.kt-datatable__table').tableExport({
            formats: ["xlsx", "csv"],
            headers: true,
            filename: `Subscription Report`
        });

        setSubscriptionTable(SubscriptionTable);
        $('.tableexport-caption').addClass('hidden');
    };

    function exportSheet(type){
        let fileName = `Subscription Report`;
        subscriptionTable.update({
            headers: true,
            formats: ["xlsx", "csv"],
            filename: fileName // pass in a new set of properties
        });

        if (type == 'xlsx') {
            $('.button-default.xlsx').click();
        } else {
            $('.button-default.csv').click();
        }
        $('.tableexport-caption').addClass('hidden');
    }

    function getExportData(sData) {
        return sData?.map(r => ({
            MembershipNo                : r.MembershipNo,
            Name                        :`${r.FirstName} ${r.LastName}`,
            Category                    : r.SubCategoryName,
            Email                       : r.Email,
            Mobile                      : r.Mobile,
            SubscriptionType            : r?.Code == 'Expired' ? `Expired` : r?.Plan,
            SubscriptionExpiresOn       : r.SubscriptionExpiresOn && moment(r.SubscriptionExpiresOn).format("DD-MM-YYYY"),
            MembershipType              : r.MembershipType,
            MembershipExpiresOn         : moment(r.MembershipExpiresOn).format("DD-MM-YYYY"),
            MembershipStatus            : (r.IsMembershipExpires == 'N') ? 'Expired' : 'Active',
            IPSCSubscriptionExpiresOn   : r.IPSCSubscriptionExpiresOn ? moment(r.IPSCSubscriptionExpiresOn).format("DD-MM-YYYY") : '',
            IPSCStatus                  : (r.IsIPSCValid == 'N') ? 'Expired' : 'Valid'
        }));
    }

    function exportSheetNew(type){
        /* @DESC ~PG
        *This Function Depends on XLSX lib attached in Public Index as CDN
        */
        const subscriptionData = subscriptionReport?.User

        if (!subscriptionData || subscriptionData.length === 0) {
            swal.fire({
                icon:'warning',
                titleText: 'No data to Export',                
                showConfirmButton: false,               
            });
            return;
        }

        let fileName = `Subscription Report - ${moment().format('YYYY-MM-DD')}`;
        const exportData = getExportData(subscriptionData);
        
        exportToExcel(type, exportData, fileName);       
    }

    
    // function exportToCsv(data, filename) {
    //     try {
    //         var csv = '';
    //         var headers = Object.keys(data[0]).join(',');
    //         csv += headers + '\n';
    
    //         data.forEach(row => {
    //             csv += Object.values(row).map(v => `"${v}"`).join(',') + '\n';
    //         });
    
    //         var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    //         var link = document.createElement('a');
    //         link.href = URL.createObjectURL(blob);
    //         link.download = filename + '.csv';
    //         link.click();            
    //     } catch (error) {
    //          console.log('Error Exporting CSV File..!')
    //     }
    // }

    // function exportToExcel(data, filename) {
    //     try {
    //         var worksheet = XLSX.utils.json_to_sheet(data);
    //         var workbook = XLSX.utils.book_new();
    //         XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');
    
    //         XLSX.writeFile(workbook, filename + '.xlsx');            
    //     } catch (error) {
    //         console.log('Error Exporting XLSX File..!')
    //     }
    // }


    return(
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content">
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body padding-t20 padding-b0">
                            <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                <div className="row justify-content-end">
                                    <div className="form-group col-sm-2">
                                        <div className="input-group">
                                            <div className="kt-input-icon kt-input-icon--left">
                                                <input 
                                                    type="text" 
                                                    className="form-control clientSearch" 
                                                    placeholder="Search..." 
                                                    id="generalSearch"
                                                />
                                                <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <div className="dropdown">
                                            <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Export
                                            </button>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)'}}>
                                                <button 
                                                    id="btn-export-excel" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    // onClick={() => exportSheet('xlsx')}
                                                    onClick={() => exportSheetNew('xlsx')}

                                                > Excel 
                                                </button>
                                                <button 
                                                    id="btn-export-csv" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    // onClick={() => exportSheet('csv')}
                                                    onClick={() => exportSheetNew('csv')}
                                                >  Csv </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="tblSubscriptionReport" className="table table-bordered table-hover custom-datatable"></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SubscriptionReport;